/* KRONHERR Gastro theme JS */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const cfg = window.KG || {};
  const moneyFormat = cfg.moneyFormat || '{{amount_with_comma_separator}} €';

  const taxIncluded = document.documentElement.dataset.taxIncluded !== 'false';
  const taxCountry = document.documentElement.dataset.taxCountry || 'DE';
  const standardVatRates = { AT: 20, BE: 21, BG: 20, CY: 19, CZ: 21, DE: 19, DK: 25, EE: 24, ES: 21, FI: 25.5, FR: 20, GR: 24, HR: 25, HU: 27, IE: 23, IT: 22, LT: 21, LU: 17, LV: 21, MT: 18, NL: 21, PL: 23, PT: 23, RO: 21, SE: 25, SI: 22, SK: 23 };
  const netPreviewAllowed = taxIncluded && Object.prototype.hasOwnProperty.call(standardVatRates, taxCountry);
  const VAT = netPreviewAllowed ? 1 + standardVatRates[taxCountry] / 100 : 1;
  const checkoutReturnKey = 'kg_checkout_return';
  let returningFromCheckout = false;
  try {
    returningFromCheckout = sessionStorage.getItem(checkoutReturnKey) === '1';
    sessionStorage.removeItem(checkoutReturnKey);
  } catch (e) {}
  if (returningFromCheckout || !netPreviewAllowed) {
    document.documentElement.classList.remove('is-b2b');
    try { localStorage.setItem('kg_mode', 'b2c'); } catch (e) {}
  }
  const isB2B = () => document.documentElement.classList.contains('is-b2b');
  function formatMoney(cents, opts) {
    let c = Number(cents) || 0;
    if (isB2B() && !(opts && opts.gross)) c = Math.round(c / VAT);
    const value = c / 100;
    const withComma = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const noDecimals = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const plain = value.toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, plain);
  }
  function isNetLine(line) {
    if (line.dataset.lineNet === 'true') return true;
    if (line.dataset.lineSellingPlan === 'true' || VAT <= 1) return false;
    const catalog = Number(line.dataset.lineCatalogUnit);
    const original = Number(line.dataset.lineOriginalUnit);
    return catalog > original && Math.abs(Math.round(catalog / VAT) - original) <= 1;
  }
  function renderMoney(root) {
    const contexts = new Set();
    $$('[data-cents]', root || document).forEach((el) => {
      const line = el.closest('[data-line-final]');
      const context = el.closest('.cart-page, [data-cart-drawer-content]');
      const lines = context ? $$('[data-line-final]', context) : [];
      const hasNet = lines.some((item) => isNetLine(item));
      if (context) contexts.add(context);
      let cents = Number(el.dataset.cents) || 0;
      let exact = false;
      if (isB2B() && line && el.closest('.line__price')) {
        const quantity = Number(line.dataset.lineQuantity) || 0;
        if (el.closest('s')) cents = Math.round(Number(line.dataset.lineOriginalUnit) / VAT) * quantity;
        else cents = isNetLine(line) ? Number(line.dataset.lineFinal) : Math.round(Number(line.dataset.lineUnit) / VAT) * quantity;
        exact = true;
      } else if (isB2B() && hasNet && !line && (el.closest('.summary__total') || el.closest('.summary__lines > div:first-child'))) {
        const subtotal = lines.reduce((sum, item) => sum + Number(item.dataset.lineFinal), 0);
        const netSubtotal = lines.reduce((sum, item) => sum + (isNetLine(item) ? Number(item.dataset.lineFinal) : Math.round(Number(item.dataset.lineUnit) / VAT) * Number(item.dataset.lineQuantity)), 0);
        cents = netSubtotal - Math.round((subtotal - cents) / VAT);
        exact = true;
      }
      if (line && el.closest('s')) {
        const final = isNetLine(line) ? Number(line.dataset.lineFinal) : Math.round(Number(line.dataset.lineUnit) / VAT) * Number(line.dataset.lineQuantity);
        el.closest('s').hidden = isB2B() && cents === final;
        el.closest('s').style.display = el.closest('s').hidden ? 'none' : '';
      }
      el.textContent = formatMoney(cents, { gross: exact });
    });
    contexts.forEach((context) => {
      const lines = $$('[data-line-final]', context);
      const hasNet = lines.some((item) => isNetLine(item));
      const allNet = lines.length > 0 && lines.every((item) => isNetLine(item));
      $$('.kg-checkout-info', context).forEach((el) => { el.style.display = hasNet ? 'none' : ''; });
      $$('.vat--b2c', context).forEach((el) => {
        if (!el.dataset.originalVatText) el.dataset.originalVatText = el.textContent;
        const netLabel = el.parentElement.querySelector('.vat--b2b');
        el.textContent = allNet && netLabel ? netLabel.textContent : el.dataset.originalVatText;
      });
    });
    if (!taxIncluded) {
      $$('.vat--b2c', root || document).forEach((el) => {
        const netLabel = el.parentElement.querySelector('.vat--b2b');
        if (netLabel) el.textContent = netLabel.textContent;
      });
    }
  }
  function setMode(m) {
    if (!netPreviewAllowed) m = 'b2c';
    document.documentElement.classList.toggle('is-b2b', m === 'b2b');
    try { localStorage.setItem('kg_mode', m); } catch (e) { /* ignore */ }
    $$('[data-mode]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.mode === m)));
    renderMoney();
    document.dispatchEvent(new CustomEvent('kg:mode', { detail: m }));
  }
  window.KG = Object.assign(cfg, { formatMoney, renderMoney, setMode });
  $$('[data-mode]').forEach((b) => { b.setAttribute('aria-pressed', String(b.dataset.mode === (isB2B() ? 'b2b' : 'b2c'))); b.addEventListener('click', () => setMode(b.dataset.mode)); });
  renderMoney();
  $$('[data-mode="b2b"]').forEach((button) => {
    button.disabled = !netPreviewAllowed;
    button.setAttribute('aria-disabled', String(!netPreviewAllowed));
  });
  function prepareCheckout() {
    try { sessionStorage.setItem(checkoutReturnKey, '1'); } catch (e) {}
    setMode('b2c');
  }
  document.addEventListener('click', (event) => {
    if (event.target.closest('[name="checkout"], a[href*="/checkout"]')) prepareCheckout();
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.submitter && event.submitter.name === 'checkout') prepareCheckout();
  }, true);
  window.addEventListener('pageshow', (event) => {
    let checkoutReturn = false;
    try {
      checkoutReturn = sessionStorage.getItem(checkoutReturnKey) === '1';
      sessionStorage.removeItem(checkoutReturnKey);
    } catch (e) {}
    if (!checkoutReturn) return;
    setMode('b2c');
    if (event.persisted) window.location.reload();
  });

  /* ---------- header ---------- */
  const header = $('.header') || ($('.header__bar') && $('.header__bar').closest('.shopify-section'));
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll(); addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- priority nav: drop items into "Mehr" when the bar gets tight ---------- */
  const nav = $('[data-nav]');
  if (nav) {
    const items = $$('[data-nav-item]', nav); const more = $('[data-nav-more]', nav); const list = more && $('[data-nav-more-list]', more);
    const pinned = items.filter((i) => i.hasAttribute('data-nav-pin')); const flex = items.filter((i) => !i.hasAttribute('data-nav-pin'));
    if (more && pinned.length) nav.insertBefore(more, pinned[0]);
    const w = new Map();
    const layout = () => {
      if (!more || getComputedStyle(nav).display === 'none') return;
      items.forEach((i) => { i.hidden = false; }); more.hidden = false;
      items.forEach((i) => w.set(i, i.getBoundingClientRect().width)); w.set(more, more.getBoundingClientRect().width);
      const gap = parseFloat(getComputedStyle(nav).columnGap || getComputedStyle(nav).gap) || 0; const avail = nav.clientWidth;
      const sum = (arr) => arr.reduce((a, i) => a + w.get(i) + gap, 0);
      if (sum(items) - gap <= avail) { more.hidden = true; return; }
      let used = sum(pinned) + w.get(more) + gap; const overflow = []; let full = false;
      flex.forEach((i) => { if (!full && used + w.get(i) + gap <= avail) used += w.get(i) + gap; else { full = true; overflow.push(i); } });
      list.innerHTML = '';
      overflow.forEach((i) => { i.hidden = true; const src = i.matches('a') ? i : i.querySelector('a'); const a = document.createElement('a'); a.className = 'drop__link'; a.href = src.href; a.textContent = src.textContent.trim(); list.appendChild(a); });
      more.hidden = overflow.length === 0;
    };
    layout(); addEventListener('resize', layout); if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout); setTimeout(layout, 300);
  }

  /* ---------- drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false; requestAnimationFrame(() => d.classList.add('is-open'));
    document.body.classList.add('drawer-open');
    const f = d.querySelector('input, button, a'); if (f) setTimeout(() => f.focus(), 120);
  }
  function closeDrawer(d) {
    if (!d) return; d.classList.remove('is-open'); document.body.classList.remove('drawer-open');
    setTimeout(() => { d.hidden = true; }, 320);
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-drawer-open')); return; }
    const c = e.target.closest('[data-drawer-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('.drawer')); return; }
    if (e.target.classList.contains('drawer__overlay')) closeDrawer(e.target.closest('.drawer'));
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer); });

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(msg, kind) {
    const t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.className = 'toast' + (kind ? ' toast--' + kind : ''); t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { t.hidden = true; }, 3200);
  }

  /* ---------- cart ---------- */
  const SECTIONS = 'cart-drawer,cart-bubble';
  function applySections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const tmp = document.createElement('div'); tmp.innerHTML = sections['cart-drawer'];
      const fresh = tmp.querySelector('[data-cart-drawer-content]');
      const cur = $('#CartDrawer [data-cart-drawer-content]');
      if (fresh && cur) cur.replaceWith(fresh);
    }
    renderMoney();
    if (sections['cart-bubble']) {
      const tmp = document.createElement('div'); tmp.innerHTML = sections['cart-bubble'];
      const fresh = tmp.querySelector('[data-cart-bubble]');
      $$('[data-cart-bubble]').forEach((b) => { if (fresh) b.replaceWith(fresh.cloneNode(true)); });
    }
  }
  async function cartAdd(items) {
    const r = await fetch(cfg.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: SECTIONS })
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || 'error');
    applySections(data.sections);
    return data;
  }
  async function cartChange(payload) {
    const r = await fetch(cfg.routes?.cart_change_url || '/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ sections: SECTIONS }, payload))
    });
    const data = await r.json(); if (!r.ok) throw new Error(data.description || 'error');
    applySections(data.sections); return data;
  }
  window.KG.cartAdd = cartAdd; window.KG.cartChange = cartChange;

  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); rm.disabled = true; try { await cartChange({ id: rm.dataset.lineRemove, quantity: 0 }); } catch (err) { toast(err.message, 'error'); } return; }
    const q = e.target.closest('[data-qty-change]');
    if (q) {
      e.preventDefault(); const input = q.parentElement.querySelector('input'); const step = Number(q.dataset.qtyChange);
      const next = Math.max(0, (Number(input.value) || 0) + step);
      try { await cartChange({ id: input.dataset.lineKey, quantity: next }); } catch (err) { toast(err.message, 'error'); }
    }
  });
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('input[data-line-key]');
    if (input) { try { await cartChange({ id: input.dataset.lineKey, quantity: Math.max(0, Number(input.value) || 0) }); } catch (err) { toast(err.message, 'error'); } }
    const note = e.target.closest('[data-cart-note]');
    if (note) fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  });

  /* simple add-to-cart forms (cards, quick add) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-add]'); if (!form) return;
    e.preventDefault(); const btn = form.querySelector('[type="submit"]'); const id = Number(form.querySelector('[name="id"]').value);
    btn.disabled = true; btn.classList.add('is-loading');
    try { await cartAdd([{ id, quantity: Number(form.querySelector('[name="quantity"]')?.value || 1) }]); openDrawer('CartDrawer'); }
    catch (err) { toast(err.message, 'error'); } finally { btn.disabled = false; btn.classList.remove('is-loading'); }
  });

  /* ---------- configurator ---------- */
  $$('[data-configurator]').forEach(initConfigurator);
  function initConfigurator(root) {
    const dataEl = root.querySelector('script[data-config]'); if (!dataEl) return;
    let data; try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
    const state = { variantId: data.selectedVariantId, care: false, accessories: new Set(), qty: 1, diameter: root.dataset.currentDiameter || null };
    const els = {
      price: $$('[data-price]', root), compare: $$('[data-compare-price]', root), sku: $('[data-sku]', root), avail: $('[data-availability]', root),
      total: $$('[data-total]', root), lines: $('[data-summary-lines]', root), title: $('[data-summary-title]', root),
      add: $('[data-add-to-cart]', root), addLabel: $$('[data-add-label]', root), care: $('[data-care-option]', root), stickyTotal: $$('[data-sticky-total]'), stickySub: $$('[data-sticky-sub]'),
      media: $('[data-gallery]', root)
    };
    const variantById = (id) => data.variants.find((v) => v.id === id);
    const currentVariant = () => variantById(state.variantId) || data.variants[0];

    const modelPending = () => root.hasAttribute('data-airreactor') && state.diameter !== root.dataset.currentDiameter;
    const compatibleAccessory = (a) => {
      if (data.family !== 'airreactor') return true;
      const model = (data.model || '').toLowerCase();
      if (a.sku === '4262544232538') return model.startsWith('ultra');
      if (a.sku === '4262544232545') return model.startsWith('ultra') || model === 'pro';
      return true;
    };
    function updateDiameter() {
      if (!root.hasAttribute('data-airreactor')) return;
      const diameterStep = $('[data-diameter-step]', root);
      if (diameterStep) diameterStep.hidden = false;
      $$('[data-model-diameter]', root).forEach((link) => { link.hidden = link.dataset.modelDiameter !== state.diameter; });
      const count = $('[data-model-count]', root);
      if (count) count.hidden = true;
      const pending = modelPending();
      const note = $('[data-model-pending]', root);
      if (note) note.hidden = !pending;
      ['[data-care-option]', '[data-accessories-step]', '[data-summary]', '[data-sticky-bar]'].forEach((selector) => {
        const el = $(selector, root); if (el) el.hidden = pending;
      });
    }

    function optionValuesToVariant() {
      const selected = $$('[data-option-index]', root).map((g) => {
        const on = g.querySelector('input:checked'); return on ? on.value : null;
      });
      return data.variants.find((v) => v.options.every((o, i) => selected[i] === null || selected[i] === o));
    }
    function updateOptionAvailability() {
      $$('[data-option-index]', root).forEach((group, gi) => {
        const selected = $$('[data-option-index]', root).map((g) => g.querySelector('input:checked')?.value ?? null);
        $$('input', group).forEach((input) => {
          const test = selected.slice(); test[gi] = input.value;
          const match = data.variants.find((v) => v.options.every((o, i) => test[i] === null || test[i] === o));
          const opt = input.closest('.opt'); opt.classList.toggle('is-unavailable', !match || !match.available);
          const p = opt.querySelector('[data-opt-price]'); if (p && match) p.textContent = match.available ? formatMoney(match.price) : data.t.sold_out;
        });
      });
    }
    function render() {
      const v = currentVariant(); if (!v) return;
      updateDiameter();
      (data.accessories || []).forEach((a) => {
        const allowed = compatibleAccessory(a);
        const input = root.querySelector(`[data-accessory][value="${a.id}"]`);
        if (!allowed || !a.available || modelPending()) {
          state.accessories.delete(a.id);
          if (input) { input.checked = false; input.closest('.opt')?.classList.remove('is-selected'); }
        }
        if (input) { input.disabled = !allowed || !a.available || modelPending(); input.closest('.opt').hidden = !allowed; }
      });
      const careTier = data.care && data.care.tiers ? pickCareTier(v.price) : null;
      const careOn = state.care && careTier;
      let total = v.price * state.qty + (careOn ? careTier.price : 0);
      els.price.forEach((el) => (el.textContent = formatMoney(v.price)));
      els.compare.forEach((el) => { if (v.compare_at_price && v.compare_at_price > v.price) { el.textContent = formatMoney(v.compare_at_price); el.hidden = false; } else el.hidden = true; });
      if (els.sku) els.sku.textContent = v.sku ? data.t.sku + ' ' + v.sku : '';
      if (els.avail) { els.avail.textContent = v.available ? (v.inventory_quantity > 0 && v.inventory_quantity <= 3 ? data.t.low_stock.replace('__count__', v.inventory_quantity) : (v.inventory_quantity > 0 || v.inventory_policy === 'continue' && !v.inventory_managed ? data.t.in_stock : data.t.backorder)) : data.t.sold_out; els.avail.className = 'avail' + (v.available ? '' : ' avail--out'); }
      if (els.title) els.title.textContent = data.title + (v.title && v.title !== 'Default Title' ? ' · ' + v.title : '');
      els.stickySub.forEach((el) => { if (v.title && v.title !== 'Default Title') el.textContent = v.title; });
      // lines
      if (els.lines) {
        let html = '';
        (data.included || []).forEach((i) => (html += `<div><b>${esc(i)}</b><span class="inc">${data.t.included}</span></div>`));
        if (careOn) html += `<div><b>${esc(data.care.title)}</b><span>${formatMoney(careTier.price)}</span></div>`;
        (data.accessories || []).forEach((a) => { if (state.accessories.has(a.id)) { total += a.price; html += `<div><b>${esc(a.title)}</b><span>${formatMoney(a.price)}</span></div>`; } });
        els.lines.innerHTML = html;
      } else { (data.accessories || []).forEach((a) => { if (state.accessories.has(a.id)) total += a.price; }); }
      els.total.forEach((el) => (el.textContent = formatMoney(total)));
      els.stickyTotal.forEach((el) => (el.textContent = formatMoney(total)));
      if (els.add) { els.add.disabled = !v.available || modelPending(); els.addLabel.forEach((l) => (l.textContent = v.available ? data.t.add_to_cart + ' · ' + formatMoney(total) : data.t.sold_out)); }
      if (els.care) { const p = els.care.querySelector('[data-opt-price]'); if (p) p.textContent = careTier ? '+' + formatMoney(careTier.price) : ''; els.care.hidden = !careTier || modelPending(); }
      // gallery: switch to variant image
      if (v.featured_media_id && els.media) { const t = els.media.querySelector(`[data-media-id="${v.featured_media_id}"]`); if (t) t.click(); }
      // url
      if (history.replaceState && data.variants.length > 1) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    function pickCareTier(price) {
      const tiers = data.care.tiers.slice().sort((a, b) => a.max - b.max);
      return tiers.find((t) => price <= t.max) || tiers[tiers.length - 1];
    }
    root.addEventListener('change', (e) => {
      if (e.target.matches('[data-option-index] input')) { const v = optionValuesToVariant(); if (v) state.variantId = v.id; updateOptionAvailability(); }
      if (e.target.matches('[data-diameter]')) { state.diameter = e.target.value; state.accessories.clear(); state.care = false; $$('[data-accessory], [data-care-toggle]', root).forEach((input) => { input.checked = false; }); }
      if (e.target.matches('[data-care-toggle]')) state.care = e.target.checked;
      if (e.target.matches('[data-accessory]')) { const id = Number(e.target.value); e.target.checked ? state.accessories.add(id) : state.accessories.delete(id); }
      if (e.target.matches('[data-qty]')) state.qty = Math.max(1, Number(e.target.value) || 1);
      $$('.opt', root).forEach((o) => { const i = o.querySelector('input'); if (i) o.classList.toggle('is-selected', i.checked); });
      render();
    });
    root.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-add-to-cart]'); if (!btn) return;
      e.preventDefault(); const v = currentVariant(); if (!v || !v.available || modelPending()) return;
      const items = [{ id: v.id, quantity: state.qty }];
      const careTier = data.care && data.care.tiers ? pickCareTier(v.price) : null;
      if (state.care && careTier) items.push({ id: careTier.id, quantity: 1, properties: { [data.t.care_for]: data.title + (v.title && v.title !== 'Default Title' ? ' · ' + v.title : '') } });
      state.accessories.forEach((id) => { const a = (data.accessories || []).find((item) => item.id === id); if (a?.available && compatibleAccessory(a)) items.push({ id, quantity: 1 }); });
      btn.disabled = true; btn.classList.add('is-loading');
      try { await cartAdd(items); openDrawer('CartDrawer'); toast(data.t.added); }
      catch (err) { toast(err.message || data.t.error, 'error'); }
      finally { btn.disabled = false; btn.classList.remove('is-loading'); }
    });
    document.addEventListener('kg:mode', () => { updateOptionAvailability(); render(); });
    updateOptionAvailability(); render();
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }

  /* ---------- gallery + lightbox ---------- */
  function swipe(el, cb) {
    if (!el) return; let x0 = null, y0 = null;
    el.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    el.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) cb(dx < 0 ? 1 : -1); }, { passive: true });
  }
  function eager(root) {
    $$('img', root).forEach((im) => {
      im.loading = 'eager'; im.decoding = 'async'; im.setAttribute('fetchpriority', 'high');
      if (!im.complete || !im.naturalWidth) { const ss = im.getAttribute('srcset'), src = im.getAttribute('src'); if (ss) { im.removeAttribute('srcset'); im.setAttribute('srcset', ss); } if (src) { im.removeAttribute('src'); im.setAttribute('src', src); } }
    });
  }
  /* non-square videos (tutorials) are letterboxed instead of cropped */
  function fitVideo(v) { const apply = () => { const r = v.videoWidth / v.videoHeight; if (r > 1.2 || r < 0.83) v.classList.add('is-wide'); }; if (v.readyState >= 1) apply(); else v.addEventListener('loadedmetadata', apply, { once: true }); }
  $$('.stage video').forEach(fitVideo);
  $$('[data-gallery]').forEach((g) => {
    const main = g.querySelector('[data-gallery-main]'); const thumbs = $$('[data-media-id]', g);
    const lb = g.querySelector('[data-lightbox]');
    if (lb && lb.parentNode !== document.body) document.body.appendChild(lb); /* escape the gallery stacking context so sticky panels cannot overlay it */
    const lbStage = lb && lb.querySelector('[data-lightbox-stage]'), lbThumbs = lb && lb.querySelector('[data-lightbox-thumbs]'), lbCount = lb && lb.querySelector('[data-lightbox-count]');
    let index = Math.max(0, thumbs.findIndex((t) => t.classList.contains('is-active')));
    function renderLightbox() {
      if (!lb || lb.hidden) return;
      lbStage.innerHTML = '';
      const tpl = thumbs[index] && thumbs[index].querySelector('template');
      if (tpl) lbStage.appendChild(tpl.content.cloneNode(true)); else if (main) lbStage.innerHTML = main.innerHTML;
      eager(lbStage);
      const v = lbStage.querySelector('video'); if (v) { fitVideo(v); v.controls = true; v.muted = false; v.loop = false; v.play().catch(() => { v.muted = true; v.play().catch(() => {}); }); } /* lightbox = watch mode: sound + controls, not the muted hero loop */
      $$('.thumb', lbThumbs).forEach((x, k) => x.classList.toggle('is-active', k === index));
      if (lbCount) lbCount.textContent = thumbs.length > 1 ? (index + 1) + ' / ' + thumbs.length : '';
    }
    function show(i) {
      if (!thumbs.length) { renderLightbox(); return; }
      index = (i + thumbs.length) % thumbs.length;
      thumbs.forEach((x, k) => x.classList.toggle('is-active', k === index));
      const tpl = thumbs[index].querySelector('template');
      if (tpl && main) { main.innerHTML = ''; main.appendChild(tpl.content.cloneNode(true)); eager(main); const v = main.querySelector('video'); if (v) { fitVideo(v); v.play().catch(() => {}); } }
      renderLightbox();
    }
    const prev = g.querySelector('[data-gallery-prev]'), next = g.querySelector('[data-gallery-next]');
    thumbs.forEach((t, k) => t.addEventListener('click', () => show(k)));
    /* photo first; the video sits behind a "Produktvideo" button that fades the stage over to it */
    const vbtn = g.querySelector('[data-gallery-video]');
    if (vbtn && main) {
      const vk = thumbs.findIndex((t) => t.dataset.mediaId === vbtn.dataset.galleryVideo);
      const sync = () => g.classList.toggle('is-video', thumbs[index] === thumbs[vk]);
      sync();
      thumbs.forEach((t) => t.addEventListener('click', sync));
      [prev, next].forEach((b) => b && b.addEventListener('click', sync));
      vbtn.addEventListener('click', (e) => { e.stopPropagation(); if (vk < 0) return; main.classList.add('is-fading'); setTimeout(() => { show(vk); sync(); requestAnimationFrame(() => main.classList.remove('is-fading')); }, 220); });
    }
    if (prev) prev.addEventListener('click', (e) => { e.stopPropagation(); show(index - 1); });
    if (next) next.addEventListener('click', (e) => { e.stopPropagation(); show(index + 1); });
    swipe(main, (d) => show(index + d));
    document.addEventListener('keydown', (e) => {
      const t = e.target; if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable)) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); } else if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    });
    if (!lb) return;
    function openLightbox() {
      if (lbThumbs && !lbThumbs.childElementCount && thumbs.length > 1) thumbs.forEach((t, k) => { const b = document.createElement('button'); b.type = 'button'; b.className = 'thumb'; b.setAttribute('aria-label', t.getAttribute('aria-label') || ''); const im = t.querySelector('img'); if (im) b.appendChild(im.cloneNode(true)); b.addEventListener('click', () => show(k)); lbThumbs.appendChild(b); });
      lb.hidden = false; document.body.classList.add('lightbox-open'); const mv = main && main.querySelector('video'); if (mv) mv.pause(); renderLightbox();
    }
    function closeLightbox() { lb.hidden = true; document.body.classList.remove('lightbox-open'); const v = lbStage.querySelector('video'); if (v) v.pause(); const mv = main && main.querySelector('video'); if (mv) mv.play().catch(() => {}); }
    if (main) main.addEventListener('click', () => openLightbox());
    $$('[data-lightbox-close]', lb).forEach((b) => b.addEventListener('click', closeLightbox));
    const lp = lb.querySelector('[data-lightbox-prev]'), ln = lb.querySelector('[data-lightbox-next]');
    if (lp) lp.addEventListener('click', () => show(index - 1)); if (ln) ln.addEventListener('click', () => show(index + 1));
    swipe(lbStage, (d) => show(index + d));
    document.addEventListener('keydown', (e) => { if (!lb.hidden && e.key === 'Escape') closeLightbox(); });
  });

  /* ---------- delivery promise (per country, client side) ---------- */
  $$('[data-promise]').forEach((box) => {
    const EU = 'AT,BE,BG,HR,CY,CZ,DK,EE,FI,FR,GR,HU,IE,IT,LV,LT,LU,MT,NL,PL,PT,RO,SK,SI,ES,SE'.split(',');
    const Z29 = 'AT,BE,NL,LU,FR,CZ,PL'.split(','), Z39 = 'ES,IT,DK,SK,HU,SI,HR'.split(',');
    const freight = box.dataset.freight === 'true';
    const days = box.dataset.days.split(','), months = box.dataset.months.split(','), cutoff = +box.dataset.cutoff;
    const sel = box.querySelector('[data-promise-country]'), nameEl = box.querySelector('[data-promise-country-name]');
    const cutEl = box.querySelector('[data-promise-cutoff]'), delEl = box.querySelector('[data-promise-delivery]'), costEl = box.querySelector('[data-promise-cost]');
    let cc = box.dataset.country;
    try { const saved = localStorage.getItem('kg_country'); if (saved && sel && [...sel.options].some((o) => o.value === saved)) cc = saved; } catch (e) {}
    if (sel && ![...sel.options].some((o) => o.value === cc)) cc = 'XX';
    if (sel) { sel.value = cc; sel.addEventListener('change', () => { cc = sel.value; try { localStorage.setItem('kg_country', cc); } catch (e) {} render(); }); }
    function rules() {
      const zone = cc === 'DE' ? 'de' : EU.includes(cc) ? 'eu' : cc === 'CH' ? 'ch' : 'row';
      let tmin = 5, tmax = 10, cost = null, ok = true;
      if (freight) {
        if (zone === 'de') { tmin = 1; tmax = 3; cost = 'free'; }
        else if (zone === 'eu') { tmin = 2; tmax = 5; cost = Z29.includes(cc) ? '29,00 €' : Z39.includes(cc) ? '39,00 €' : '49,00 €'; }
        else if (zone === 'ch') { tmin = 2; tmax = 5; cost = '69,00 €'; }
        else ok = false;
      } else {
        if (zone === 'de') { tmin = 1; tmax = 3; cost = 'free'; }
        else if (zone === 'eu') { tmin = 2; tmax = 4; cost = '9,99 €'; }
        else { cost = '9,99 €'; }
      }
      return { tmin, tmax, cost, ok };
    }
    const berlin = (d) => new Date(d.toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
    const addWork = (d, n, sat) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && (sat || x.getDay() !== 6)) n--; } return x; };
    const fmt = (d) => days[d.getDay()] + ' ' + d.getDate() + '. ' + months[d.getMonth()];
    function render() {
      const r = rules();
      if (nameEl && sel) nameEl.textContent = sel.options[sel.selectedIndex].textContent;
      if (!r.ok) { cutEl.innerHTML = '<b>' + box.dataset.tNofreight + '</b>'; delEl.textContent = ''; costEl.textContent = ''; return; }
      const now = berlin(new Date());
      const wd = now.getDay() !== 0 && now.getDay() !== 6, beforeCut = now.getHours() < cutoff;
      let ship;
      if (wd && beforeCut) {
        ship = new Date(now);
        const mins = cutoff * 60 - (now.getHours() * 60 + now.getMinutes());
        cutEl.innerHTML = box.dataset.tWithin.replace('__T__', '<b>' + Math.floor(mins / 60) + 'h ' + String(mins % 60).padStart(2, '0') + 'min</b>');
      } else {
        ship = addWork(now, 1, false);
        const isTomorrow = (ship - new Date(now.getFullYear(), now.getMonth(), now.getDate())) < 2 * 86400000;
        cutEl.innerHTML = box.dataset.tNext.replace('__D__', '<b>' + (isTomorrow ? box.dataset.tomorrow + ' (' + days[ship.getDay()] + ')' : box.dataset.on + ' ' + fmt(ship)) + '</b>');
      }
      const a = addWork(ship, r.tmin, !freight), b = addWork(ship, r.tmax, !freight); /* parcels are delivered on Saturdays too */
      const range = a.getMonth() === b.getMonth() ? days[a.getDay()] + ' ' + a.getDate() + '. ' + box.dataset.to + ' ' + fmt(b) : fmt(a) + ' ' + box.dataset.to + ' ' + fmt(b);
      delEl.innerHTML = (freight ? box.dataset.tDeliveryFreight : box.dataset.tDelivery).replace('__R__', '<b>' + range + '</b>');
      costEl.innerHTML = r.cost === 'free' ? '<b>' + box.dataset.tFree + '</b>' : (freight ? box.dataset.tFreight : box.dataset.tParcel).replace('__P__', r.cost);
    }
    render(); setInterval(render, 30000);
  });

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  } else $$('.reveal').forEach((el) => el.classList.add('is-in'));

  /* ---------- predictive search ---------- */
  const searchInput = $('[data-predictive-input]'); const searchResults = $('[data-predictive-results]');
  if (searchInput && searchResults) {
    let t; searchInput.addEventListener('input', () => {
      clearTimeout(t); const q = searchInput.value.trim(); if (q.length < 2) { searchResults.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const r = await fetch(`${cfg.routes?.predictive_search_url || '/search/suggest'}?q=${encodeURIComponent(q)}&resources[type]=product,page&resources[limit]=6&section_id=predictive-search`);
          const html = await r.text(); const tmp = document.createElement('div'); tmp.innerHTML = html;
          const inner = tmp.querySelector('#shopify-section-predictive-search'); searchResults.innerHTML = inner ? inner.innerHTML : '';
        } catch (err) { /* ignore */ }
      }, 220);
    });
  }

  /* ---------- collection filters (client side) ---------- */
  const filterBar = $('[data-filter-bar]');
  if (filterBar) {
    filterBar.addEventListener('change', () => {
      const brands = $$('input[name="brand"]:checked', filterBar).map((i) => i.value);
      const stock = $('input[name="instock"]', filterBar)?.checked;
      let n = 0;
      $$('[data-product-card]').forEach((c) => {
        const ok = (!brands.length || brands.includes(c.dataset.vendor)) && (!stock || c.dataset.available === 'true');
        c.hidden = !ok; if (ok) n++;
      });
      const count = $('[data-results-count]'); if (count) count.textContent = count.dataset.template.replace('__count__', n);
    });
    const sort = $('[data-sort-select]'); if (sort) sort.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); location.href = u; });
  }

  /* ---------- sticky buy bar (top, under header) ---------- */
  const sticky = $('[data-sticky-bar]'); const buyHead = $('[data-buy-head]'); const summaryEl = $('[data-summary]');
  if (sticky && buyHead) {
    let ticking = false;
    const update = () => {
      ticking = false;
      const headBottom = buyHead.getBoundingClientRect().top + 140;
      const sumRect = summaryEl ? summaryEl.getBoundingClientRect() : null;
      const summaryVisible = sumRect && sumRect.top < window.innerHeight - 80 && sumRect.bottom > 90;
      sticky.classList.toggle('is-visible', headBottom < 0 && !summaryVisible);
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    addEventListener('scroll', onScroll, { passive: true }); addEventListener('resize', onScroll); update();
  }
})();
